{
  "title": "Аудит обогащения",
  "columns": {
    "@timestamp": "Дата",
    "ci_type_label": "Имя ТКЕ",
    "ci_name": "Имя КЕ",
    "start_time": "Время начала",
    "end_time": "Время окончания",
    "execution_status": {
      "label": "Статус выполнения",
      "finished": "Завершено",
      "running": "В процессе"
    },
    "unique_ci_count": "Уникальных КЕ",
    "doc_count": "Количество этапов",
    "message": "Сообщение",
    "errors": "Ошибки",
    "event_type": "Тип события",
    "overall_status": "Статус",
    "status": "Статус по КЕ",
    "duration": "Длительность",
    "attribute": "Атрибут"
  },
  "views": {
    "grid": "Журнал обогащения",
    "timeline": "Задачи обогащения"
  },
  "statistics": {
    "srm.statistic.CIEnrichmentSuccess": "КЕ успешно обогащен",
    "srm.statistic.CIEnrichmentError": "Ошибка обогащения КЕ",
    "srm.statistic.CIEnrichmentWarning": "Предупреждение обогащения КЕ",
    "srm.statistic.AttrEnrichmentSuccess": "Атрибут успешно обогащен",
    "srm.statistic.AttrEnrichmentError": "Ошибка обогащения атрибута",
    "srm.statistic.AttrEnrichmentWarning": "Предупреждение обогащения атрибута",
    "srm.statistic.LinkEnrichmentSuccess": "Связь успешно обогащена",
    "srm.statistic.LinkEnrichmentError": "Ошибка обогащения связи",
    "srm.statistic.LinkEnrichmentWarning": "Предупреждение обогащения связи",
    "srm.statistic.AdditionalLinkFinished": "Дополнительная связь завершена"
  }
}